export const reservationInvoicePanel = {
  loadingVerifying: "Verifica in corso…",

  status: {
    draft: "Bozza",
    sent: "Emessa",
    processing: "In elaborazione",
    pending: "In sospeso",
    error: "Errore",
    corrected: "Rettificata",
    voided: "Annullata",
  },

  common: {
    cancel: "Annulla",
    understood: "Ho capito",
    optional: "facoltativo",
    optionalParen: "(facoltativo)",
    sending: "Invio in corso…",
    saving: "Salvataggio in corso…",
    deleting: "Eliminazione in corso…",
    emitting: "Emissione in corso…",
    creating: "Creazione in corso…",
    retrying: "Nuovo tentativo in corso…",
  },

  issued: {
    title: "Fatture emesse",
    rectifOf: "Rettifica di {code}",
    viewPdf: "Visualizza PDF",
    sendByWhatsapp: "Invia via WhatsApp",
    correctTitle: "Rettifica (fattura rettificativa)",
    voidTitle: "Annulla (fattura rettificativa)",
  },

  empty: {
    guestRequested: "L'ospite ha richiesto la sua fattura",
    noInvoice: "Nessuna fattura emessa",
    linkSent: "Link inviato",
    requested: "Richiesta",
    requestedSub: "Controlla i suoi dati ed emetti la fattura, oppure inviagli il link per confermare.",
    sub: "Invia il link all'ospite o crea direttamente la fattura.",
    copyLinkTitle: "Copia link negli appunti",
    sendLink: "Invia link",
    createInvoice: "Crea fattura",
    configureHint: "Configura i tuoi dati di fatturazione per abilitare questa funzione.",
  },

  next: {
    title: "Questa prenotazione ha già la sua fattura",
    sub: "C'è stato un addebito successivo? Crea un'altra fattura per questa prenotazione: includerà solo i nuovi addebiti (l'alloggio già fatturato non viene ripetuto).",
    button: "Crea un'altra fattura per questa prenotazione",
  },

  card: {
    draftRefTitle: "Riferimento interno della bozza. Il numero fiscale viene assegnato all'emissione.",
  },

  draft: {
    emptyHint: 'Aggiungi almeno un addebito in <b>“Nuovi addebiti”</b> per emettere questa fattura.',
    noteLead: "Bozza — modifica i dati o aggiungi addebiti sopra; il numero e la data vengono assegnati all'<b>emissione</b>.",
    nextSequential: "Prossimo numero progressivo",
    estimated: "stimato",
    noteFoot: "Il numero non è definitivo: lo ottiene il primo che emette.",
    confirmEmit: "Conferma ed emetti la fattura",
    previewPdf: "Anteprima PDF",
    sendQuote: "Invia preventivo",
    edit: "Modifica fattura",
    discard: "Scarta",
  },

  // Righe del documento in corso: ciò che si controlla PRIMA di emettere.
  concepts: {
    title: "Righe del documento",
    item: "Articolo",
    qty: "Qtà",
    unitPrice: "Prezzo unit.",
    vat: "IVA",
    amount: "Importo",
    linesTotal: "Totale delle righe",
    foot: "Il dettaglio apparirà così sulla fattura. Il PDF contiene il dettaglio completo.",
    mismatch: "Il totale delle righe ({lines}) non corrisponde al totale del documento ({total}). Controllalo prima di emettere.",
  },

  // Lo cobrado y lo que queda a deber. Mismas palabras y mismo orden que el
  // pie del PDF, para que leer la pantalla y leer la factura sea lo mismo.
  cobro: {
    total: "Totale del documento",
    nothing: "Nessun incasso registrato",
    due: "Da incassare",
    assumed: "Non risultano incassi su questa prenotazione. L'importo viene dato per incassato in base al metodo di pagamento indicato, e il PDF dirà lo stesso. Se non hai ancora incassato, registra l'incasso o cambia il metodo di pagamento.",
  },

  actions: {
    sendWhatsapp: "Invia WhatsApp",
    correct: "Rettifica",
    void: "Annulla",
    refresh: "Aggiorna",
    retry: "Riprova",
    editData: "Modifica dati",
    delete: "Elimina",
  },

  wa: {
    title: "Invia la fattura via WhatsApp",
    desc: "La fattura <strong>{code}</strong> verrà inviata all'ospite in formato PDF via WhatsApp.",
    issuedFallback: "emessa",
    checkPhone: "Verrà utilizzato il telefono dell'ospite collegato alla prenotazione",
    checkPdf: "Il documento verrà inviato in formato PDF",
    send: "Invia fattura",
  },

  sendLink: {
    title: "Invia il link di fatturazione",
    desc: "All'ospite verrà inviato un <strong>link WhatsApp</strong> per confermare i propri dati fiscali e scaricare la fattura.",
    checkNoInvoice: "Non viene ancora emessa alcuna fattura: l'ospite riceve solo il link",
    button: "Invia link",
  },

  retryModal: {
    title: "Riprova l'emissione",
    desc: "Proveremo a <strong>emettere di nuovo questa fattura</strong> con i dati attuali.",
    check1: "Viene reinviata all'autorità di fatturazione elettronica",
    check2: "Se va a buon fine, viene assegnato il numero fiscale definitivo",
  },

  voidModal: {
    doneTitle: "Fattura annullata — Fattura rettificativa emessa",
    creditNoteIssued: "Fattura rettificativa <strong>{code}</strong> emessa",
    chargesReleased: "Gli addebiti aggiuntivi sono stati liberati",
    clientCanRequest: "Il cliente può richiedere nuovamente la fattura",
    doneHint: "Aggiungi o correggi gli addebiti in sospeso e crea una nuova fattura.",
    formTitle: "Annulla fattura / Emetti fattura rettificativa",
    formDesc: "Usa questa opzione quando devi <strong>aggiungere o modificare servizi/importi</strong>. Verrà emessa una <strong>fattura rettificativa</strong> che annulla la fattura originale e potrai creare una nuova fattura con gli addebiti corretti.",
    stepAnnul: "Viene emessa una fattura rettificativa fiscale che annulla {code}",
    stepFree: "Gli addebiti vengono liberati per aggiungere o correggere",
    stepNewNumber: "Viene creata una nuova fattura con il numero successivo",
    notice: "Per correggere solo il NIF, il nome o l'indirizzo senza modificare gli importi, usa invece <strong>Modifica dati</strong>.",
    voiding: "Emissione fattura rettificativa…",
    confirm: "Annulla ed emetti fattura rettificativa",
  },

  edit: {
    titleDraft: "Modifica fattura",
    titleClient: "Modifica dati del cliente",
    descDraft: "Le modifiche vengono salvate istantaneamente. I dati fiscali vengono convalidati senza emettere.",
    descSent: "Al salvataggio, l'invio verrà ritentato automaticamente.",
    type: "Tipo",
    individual: "Privato",
    individualSub: "Persona fisica",
    company: "Azienda",
    companySub: "Persona giuridica",
    legalName: "Ragione sociale",
    fullName: "Nome completo",
    legalNamePlaceholder: "Ragione sociale dell'azienda",
    fullNamePlaceholder: "Nome e cognome",
    country: "Paese",
    countryPlaceholder: "Seleziona il paese dell'ospite",
    taxRequiredOnEmit: "obbligatorio all'emissione",
    taxIdPlaceholderCompany: "NIF / CIF dell'azienda",
    taxIdPlaceholderIndividual: "DNI / NIE · vuoto = consumatore finale",
    email: "Email",
    emailPlaceholder: "email@example.com",
    phone: "Telefono",
    phonePlaceholder: "+34 600 000 000",
    fiscalAddress: "Indirizzo fiscale",
    addressPlaceholder: "Via e numero",
    city: "Città",
    region: "Regione / Provincia",
    zip: "Codice postale",
    saveChanges: "Salva le modifiche",
    saveAndRetry: "Salva e riprova",
  },

  deleteModal: {
    title: "Elimina fattura",
    desc: "Questo tentativo di fattura verrà eliminato. Il cliente potrà richiedere nuovamente la fattura da zero.",
    noticeIrreversible: "Questa azione non può essere annullata.",
  },

  emit: {
    title: "Conferma ed emetti la fattura",
    subtitle: "Viene registrata ufficialmente",
    desc: "Stai per emettere la fattura per {name}.",
    stepNumberEstimate: "Le viene assegnato il numero progressivo <b>{code}</b> — lo ottiene il primo che emette.",
    stepNumberFinal: "Le viene assegnato il numero progressivo <b>definitivo</b> — lo ottiene il primo che emette.",
    stepPdf: "Il PDF fiscale viene generato e trasmesso all'autorità fiscale.",
    warn: "Una volta emessa <b>non può essere modificata</b>. In caso di errore, dovrai <b>annullarla e creare una nuova fattura</b> (fattura rettificativa o rettifica).",
    confirm: "Conferma ed emetti",
  },

  newInvoice: {
    title: "Crea un'altra fattura",
    subtitle: "Per questa stessa prenotazione",
    desc: "Verrà aperta una <strong>nuova bozza</strong> per questa prenotazione.",
    step1: "Includerà <b>solo i nuovi addebiti</b> che aggiungi — l'alloggio già fatturato non viene ripetuto.",
    step2: "Riprende gli stessi dati del cliente. Il numero viene assegnato all'emissione.",
    createDraft: "Crea bozza",

    // Facturar toda la reserva o una sola habitación (reservas de varias).
    scopeTitle: "Come vuoi fatturare?",
    whole: "Tutta la prenotazione",
    wholeHint: "Una sola fattura con le {n} camere.",
    perRoom: "Una camera",
    perRoomHint: "Ogni camera, la sua fattura. Per quando ogni ospite paga la sua parte.",
    pickRoom: "Scegli la camera",
    roomLodging: "Alloggio",
    alreadyInvoiced: "già fatturata",
  },

  correction: {
    doneTitle: "Rettifica emessa",
    createdOk: "Rettifica <strong>{code}</strong> creata con successo",
    originalKept: "La fattura originale rimane come riferimento fiscale (non viene eliminata)",
    pdfSoon: "Il PDF verrà generato a breve",
    title: "Rettifica fattura",
    infobox: "Verrà emessa una <strong>fattura rettificativa rettificativa</strong> che sostituisce fiscalmente <strong>{code}</strong> e include gli addebiti attuali della prenotazione. Il numero originale non può essere modificato (è la legge).",
    reasonLabel: "Motivo della rettifica",
    selectReason: "— Seleziona un motivo —",
    reasonTaxId: "NIF / CIF o codice fiscale errato",
    reasonName: "Nome o ragione sociale errati",
    reasonAddress: "Indirizzo fiscale errato",
    reasonEmail: "Email errata",
    reasonGeneral: "Rettifica generale dei dati fiscali",
    reasonOther: "Altro (scrivi il motivo)",
    customReasonPlaceholder: "Descrivi il motivo della rettifica…",
    recipientDivider: "Dati del destinatario — modifica solo ciò che devi correggere",
    nameOrLegalName: "Nome / Ragione sociale",
    taxIdFull: "NIF / CIF / Codice fiscale / Passaporto",
    countryTwoLetters: "(2 lettere)",
    paymentDivider: "Metodo di pagamento",
    paymentLabel: "Tipo di pagamento",
    paymentUnspecified: "— Non specificato —",
    paymentCash: "Contanti",
    paymentCard: "Carta di credito / debito",
    paymentTransfer: "Bonifico bancario",
    paymentStripe: "Stripe (online)",
    emitRectif: "Emetti rettifica",
  },

  request: {
    typeCompany: "Azienda",
    typeIndividual: "Privato",
    type: "Tipo",
    legalName: "Ragione sociale / Nome",
    taxId: "NIF / CIF",
    address: "Indirizzo",
    postalCode: "Codice postale",
    city: "Città",
    state: "Provincia",
    country: "Paese",
    email: "Email",
  },

  toast: {
    linkSent: "Link di fatturazione inviato all'ospite via WhatsApp.",
    alreadyIssued: "Questa prenotazione ha già una fattura emessa.",
    cantSendLink: "Non è stato possibile inviare il link.",
    linkCopied: "Link copiato negli appunti.",
    alreadyHasInvoice: "Questa prenotazione ha già una fattura.",
    cantGenerateLink: "Non è stato possibile generare il link.",
    cantSendWhatsapp: "Non è stato possibile inviarla via WhatsApp.",
    invoiceSentWhatsapp: "Fattura inviata via WhatsApp.",
    draftCreatedNewCharges: "Bozza creata con i nuovi addebiti (senza ripetere l'alloggio). Controllala ed emettila.",
    draftCreated: "Bozza creata. Aggiungi gli addebiti ed emettila quando è pronta.",
    alreadyInProgress: "Questa prenotazione ha già una fattura in corso.",
    cantCreateDraft: "Non è stato possibile creare la bozza.",
    invoiceEmitted: "Fattura emessa. Generazione del numero e del PDF…",
    cantEmit: "Non è stato possibile emettere la fattura.",
    cantPreview: "Non è stato possibile generare l'anteprima.",
    quoteSent: "Preventivo inviato a {email}",
    cantSendQuote: "Impossibile inviare il preventivo",
    cantSync: "Non è stato possibile sincronizzare lo stato.",
    retrying: "Nuovo tentativo di emissione…",
    cantRetry: "Impossibile riprovare.",
    cantVoid: "Errore durante l'annullamento della fattura.",
    savedCheckFiscal: "Salvato. Controlla il documento fiscale.",
    dataUpdated: "Dati aggiornati.",
    cantSaveData: "Non è stato possibile salvare i dati.",
    invoiceDeleted: "Fattura eliminata.",
    cantDelete: "Impossibile eliminare.",
    cantEmitRectif: "Errore durante l'emissione della rettifica.",
  },
};
